import { Spin } from 'antd';

const renderLoader = (props) => {

    return (
        <div style={props.style}>
            <Spin size="large" />
        </div>
    );
};

export default renderLoader;
